import { createBrowserRouter, Navigate } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { ProtectedRoute, PublicOnlyRoute } from '@/components/auth/ProtectedRoute';
import { AdminRoute } from '@/components/auth/AdminRoute';
import {
  AdminDashboardPage,
  GuestPage,
  JoinRoomPage,
  LazyPage,
  LoginPage,
  NotFoundPage,
  PrivacyPage,
  PwaDebugPage,
  RegisterPage,
  RoomPage,
  RoomsPage,
  SettingsPage,
} from './LazyPage';

export const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  {
    path: '/login',
    element: (
      <LazyPage>
        <PublicOnlyRoute>
          <LoginPage />
        </PublicOnlyRoute>
      </LazyPage>
    ),
  },
  {
    path: '/register',
    element: (
      <LazyPage>
        <PublicOnlyRoute>
          <RegisterPage />
        </PublicOnlyRoute>
      </LazyPage>
    ),
  },
  {
    path: '/guest',
    element: (
      <LazyPage>
        <PublicOnlyRoute>
          <GuestPage />
        </PublicOnlyRoute>
      </LazyPage>
    ),
  },
  {
    path: '/join',
    element: (
      <LazyPage>
        <ProtectedRoute>
          <JoinRoomPage />
        </ProtectedRoute>
      </LazyPage>
    ),
  },
  { path: '/dashboard', element: <Navigate to="/" replace /> },
  {
    path: '/admin',
    element: (
      <LazyPage>
        <AdminRoute>
          <AdminDashboardPage />
        </AdminRoute>
      </LazyPage>
    ),
  },
  {
    path: '/rooms',
    element: (
      <LazyPage>
        <ProtectedRoute>
          <RoomsPage />
        </ProtectedRoute>
      </LazyPage>
    ),
  },
  { path: '/matches', element: <Navigate to="/" replace /> },
  { path: '/matches/:id', element: <Navigate to="/" replace /> },
  { path: '/teams/:id', element: <Navigate to="/" replace /> },
  { path: '/competitions/:slug', element: <Navigate to="/" replace /> },
  {
    path: '/settings',
    element: (
      <LazyPage>
        <ProtectedRoute>
          <SettingsPage />
        </ProtectedRoute>
      </LazyPage>
    ),
  },
  {
    path: '/room/:roomId',
    element: (
      <LazyPage>
        <ProtectedRoute>
          <RoomPage />
        </ProtectedRoute>
      </LazyPage>
    ),
  },
  { path: '/home', element: <Navigate to="/" replace /> },
  {
    path: '/privacy',
    element: (
      <LazyPage>
        <PrivacyPage />
      </LazyPage>
    ),
  },
  {
    path: '/pwa-debug',
    element: (
      <LazyPage>
        <PwaDebugPage />
      </LazyPage>
    ),
  },
  {
    path: '*',
    element: (
      <LazyPage>
        <NotFoundPage />
      </LazyPage>
    ),
  },
]);
